(function () {
  var STORAGE_KEY = 'll:wishlist:v1';

  function read() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('ll:wishlist:change', { detail: { items: items } }));
  }

  function normalize(item) {
    return {
      id: String(item.id || ''),
      variantId: String(item.variantId || ''),
      handle: item.handle || '',
      title: item.title || '',
      url: item.url || '#',
      image: item.image || '',
      price: item.price || '',
      installments: item.installments || ''
    };
  }

  function getProductFromButton(button) {
    return normalize({
      id: button.dataset.productId,
      variantId: button.dataset.productVariantId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      installments: button.dataset.productInstallments
    });
  }

  function hasProduct(items, id) {
    return items.some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(product) {
    if (!product.id) return;

    var items = read();
    if (hasProduct(items, product.id)) {
      items = items.filter(function (item) {
        return String(item.id) !== String(product.id);
      });
    } else {
      items.unshift(product);
    }

    write(items);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-ll-wishlist-toggle]').forEach(function (button) {
      var active = hasProduct(items, button.dataset.productId);
      button.classList.toggle('is-active', active);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');

      var label = button.querySelector('span');
      if (label && button.classList.contains('ll-product__fav-btn')) {
        label.textContent = active ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
      }
    });
  }

  function updateCounters(items) {
    document.querySelectorAll('[data-ll-wishlist-count]').forEach(function (counter) {
      counter.textContent = items.length;
      counter.hidden = items.length === 0;
    });
  }

  function renderList(items) {
    var list = document.querySelector('[data-ll-wishlist-list]');
    if (!list) return;
    var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

    list.innerHTML = items.map(function (item) {
      var image = item.image
        ? '<a class="ll-wishlist-card__media" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></a>'
        : '<a class="ll-wishlist-card__media" href="' + escapeHtml(item.url) + '"></a>';

      var addButton = item.variantId
        ? '<form method="post" action="' + escapeHtml(cartAddUrl) + '" class="ll-wishlist-card__form"><input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '"><button type="submit" class="ll-wishlist-card__add">Adicionar ao carrinho</button></form>'
        : '';

      return [
        '<article class="ll-wishlist-card" data-ll-wishlist-item="' + escapeHtml(item.id) + '">',
          image,
          '<div class="ll-wishlist-card__body">',
            '<a href="' + escapeHtml(item.url) + '" class="ll-wishlist-card__title">' + escapeHtml(item.title) + '</a>',
            item.price ? '<p class="ll-wishlist-card__price">' + escapeHtml(item.price) + '</p>' : '',
            item.installments ? '<p class="ll-wishlist-card__installments">' + escapeHtml(item.installments) + '</p>' : '',
            '<div class="ll-wishlist-card__actions">',
              addButton,
              '<a href="' + escapeHtml(item.url) + '" class="ll-wishlist-card__view">Ver produto</a>',
              '<button type="button" class="ll-wishlist-card__remove" data-ll-wishlist-remove="' + escapeHtml(item.id) + '">Remover</button>',
            '</div>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function refresh() {
    var items = read();
    updateButtons(items);
    updateCounters(items);
    renderList(items);
  }

  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('[data-ll-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(getProductFromButton(toggleButton));
      return;
    }

    var removeButton = event.target.closest('[data-ll-wishlist-remove]');
    if (removeButton) {
      var items = read().filter(function (item) {
        return String(item.id) !== String(removeButton.dataset.llWishlistRemove);
      });
      write(items);
    }
  });

  window.addEventListener('ll:wishlist:change', function (event) {
    var items = event.detail && event.detail.items ? event.detail.items : read();
    updateButtons(items);
    updateCounters(items);
    renderList(items);
  });

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
